/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

function CitServicesReport({ reportData }: any) {
  const nf = Intl.NumberFormat();
  return (
    <div className="overflow-auto mt-8">
      <table
        className="table table-responsive mb-4 w-full"
        style={{ tableLayout: "fixed", borderCollapse: "collapse" }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "left",
                paddingLeft: "2px",
                width: "130px",
              }}
            >
              Customer
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                width: "110px",
              }}
            >
              Emirates
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                width: "100px",
              }}
            >
              Job Date
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "100px",
              }}
            >
              Start Time
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "100px",
              }}
            >
              Completion Time
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "100px",
              }}
            >
              Job Type
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "left",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "150px",
              }}
            >
              From Location
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "left",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "150px",
              }}
            >
              Final Location
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "100px",
              }}
            >
              Commodity Type
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "150px",
              }}
            >
              Order Id
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                borderCollapse: "collapse",
                width: "100px",
              }}
            >
              Invoice Type
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "80px",
              }}
            >
              Service Type
            </th>

            <th
              rowSpan={2}
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "80px",
                borderCollapse: "collapse",
              }}
            >
              Order Value
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "80px",
                borderCollapse: "collapse",
              }}
            >
              Status
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "80px",
              }}
            >
              Collection RouteNo
            </th>
            <th
              style={{
                border: "0.01rem solid grey",
                fontSize: "0.8rem",
                textAlign: "center",
                paddingLeft: "2px",
                whiteSpace: "normal",
                width: "80px",
              }}
            >
              Delivery RouteNo
            </th>
          </tr>
        </thead>
        <tbody>
          {reportData.map((req: any, i: number) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={i}>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.customer}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.city}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.serviceDate}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.startDate}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.completionDate}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.jobNature}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.sourceLocation}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.onwardLocation}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.commodityType}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.orderId}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.invoicingModel}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                    wordWrap: "break-word",
                  }}
                >
                  {req.serviceType}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.orderValue ? nf.format(req.orderValue as number) : ""}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.status}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.collectionRouteNo}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.01rem solid grey",
                    fontSize: "0.7rem",
                    paddingLeft: "2px",
                    whiteSpace: "normal",
                    borderCollapse: "collapse",
                  }}
                >
                  {req.deliveryRouteNo}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default React.memo(CitServicesReport);
